<script>
export default {
  render(h) {
    const shouldLink = this.$route.name !== `home`

    return h(
      shouldLink ? `router-link` : `span`,
      {
        props: {
          to: shouldLink ? { name: `home` } : null,
        },
        attrs: {
          class: `font-light no-underline`,
        },
      },
      [this.$slots.default]
    )
  },
}
</script>
